// Color tokens sourced from Figma Design System
// https://www.figma.com/design/W3YeU8lkVPvaswKHglfzNz/

export const colors = {
  basics: {
    white: '#ffffff',
    black: '#000000',
    grey: '#605c62',
  },

  primary: {
    25: '#fdf9ff',
    100: '#f2e5ff',
    200: '#e2d0f4',
    500: '#7f00ff',
    700: '#440b7c',
    800: '#300258',
    900: '#1e0338',
  },

  shades: {
    0: '#ffffff',
    25: '#fbfbfb',
    50: '#f6f6f6',
    100: '#ededed',
    200: '#dad9e0',
    300: '#b4afc0',
    400: '#847e96',
    500: '#655e7c',
    600: '#4a3f57',
    800: '#2a2133',
    900: '#1c1324',
    1000: '#000000',
  },

  green: {
    200: '#dcf6e0',
    300: '#bbe9c2',
    500: '#03b620',
  },

  red: {
    200: '#ffe8ee',
    300: '#ffcbd8',
    500: '#ff1a51',
  },

  orange: {
    200: '#ffeed6',
    500: '#ff6320',
  },

  blue: {
    200: '#d8e5ff',
    500: '#0056ff',
  },

  yellow: {
    200: '#fff2c5',
    500: '#ffc700',
  },

  pink: {
    200: '#ffd2f8',
    500: '#d700b5',
  },

  brand: {
    navy: '#181829',
  },
} as const

export type Colors = typeof colors
